import styled from '@emotion/styled';
import { layout } from '../tokens';

export const SectionWrapper = styled.section`
  display: block;
  width: 100%;
  max-width: 100vw;
  padding: ${layout.spacing * 5}px 0;
  text-align: center;
  color: #636468;
  margin: 2.5rem auto;
`;

interface ContentProps {
  fullWidth?: boolean;
}

export const SectionContent = styled.div<ContentProps>`
  display: block;
  width: 100%;
  ${({ fullWidth }) => {
    if (!fullWidth) {
      return `
        max-width: 1300px;
        margin: 0 auto;
        padding: 0 ${layout.spacing * 2}px;
        @media (min-width: 400px) {
          padding: 0 ${layout.spacing * 2}px;
        }
        @media (min-width: 600px) {
          padding: 0 ${layout.spacing * 3}px;
        }
        @media (min-width: 800px) {
          padding: 0 ${layout.spacing * 4}px;
        }
        @media (min-width: 1000px) {
          padding: 0 ${layout.spacing * 5}px;
        }
        @media (min-width: 1200px) {
          padding: 0 ${layout.spacing * 6}px;
        }
      `;
    }
    return '';
  }};
`;

interface DescriptionProps {
  noMargin?: boolean;
  noDescription?: boolean;
}

export const SectionTitle = styled.h1<DescriptionProps>`
  font-size: 1.5rem;
  position:relative;text-align:left;display:inline-block;margin-bottom:30px;padding-bottom:6px;
  &:after{content:"";position:absolute;text-align:center;height:2px;width:100%;left:0;right:0;background:#636468;top:100%;}
  @media (max-width: 450px) {
    font-size: 1.1rem;
  }
`;

export const SectionSubTitle = styled.h2<DescriptionProps>`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  font-size: 1.2rem;
  line-height: 2.5rem;
  font-weight: 500;
  margin-bottom: ${({ noMargin }) => (noMargin ? 0 : layout.spacing * 2)}px;
`;

export const SectionDescription = styled.p<DescriptionProps>`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  font-size: 1.0rem;
  line-height: 2rem;
  margin-bottom: ${({ noMargin }) => (noMargin ? 0 : layout.spacing * 2)}px;
`;
